import { attr } from '@square/dashboard-data/utils/ember-model-stubs';
import BaseAddonsSettings from './base-addons-settings';
export default BaseAddonsSettings.extend({
  isTimeTrackingEnabled: attr(Boolean, {
    defaultValue: true
  })
});